import type { FoldingCardProp } from "@components/FoldingCardProp.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getReasonsEcommerce(tenant: Tenant): FoldingCardProp[] {
	return [
		{
			title: "E-shop 100 % na míru",
			desc: "Šablony a krabicová řešení necháváme na jiných. sp[[Ve Fastest děláme e-commerce řešení 100 % na míru.]]",
			bg: "bg-fstgrey-500",
		},
		{
			title: "All In One řešení",
			desc: "Nemusíte kvůli každé části e-commerce shánět jiného dodavatele – sp[[zajistíme pro vás vše „pod jednou střechou“.]]",
			bg: "bg-fstgrey-600",
		},
		{
			title: "Dlouhodobá podpora a údržba",
			desc: "Po celou dobu provozování e-shopu sp[[vám bude k ruce naše specializovaná podpora.]] Rádi vám pomůžeme i s dalším rozvojem online obchodu.",
			bg: "bg-fstgrey-700",
		},
		{
			title: "Vyvíjíme na cloudu",
			desc: "sp[[Specializujeme se na cloudová řešení,]] tím vám ušetříme peníze za servery, které byste jinak museli provozovat a starat se o ně.",
			bg: "bg-fstgrey-800",
		},
		{
			title: "Škálovatelnost e-shopu",
			desc: "E-shop sp[[přizpůsobíme rychle rostoucímu byznysu,]] a to v jakékoliv fázi vašeho podnikání.",
			bg: "bg-fstgrey-900",
		},
	];
}
